<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ehXPdN/tc-custom/9781423608776.jpg?1718106413132" alt="This image is the cover for the book 75 Exceptional Herbs for Your Garden"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">75 Exceptional Herbs for Your Garden
      </h1>
      <p class="bookDescription body article font2">
        <b>An A-to-Z journey through a wide variety of herbs and their fascinating history of medicinal and culinary uses—includes illustrations!</b><br/>  <br/> Discover some unique additions to your garden in this reference filled with fascinating facts, unexpected lore, elegant prose, and beautiful watercolor illustrations by Ellen Buchert.<br/>  <br/> From popular herbs like basil, lavender, and peppermint to lesser-known choices like meadowsweet and soapwort, this is a treasury that reveals how much botanical variety can be found in the world of herbs. Sometimes masquerading as common denizens of our fields and forests, these are plants that will not only decorate our gardens, but will capture the imagination of any gardener or cook!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Staub, Ellen Buchert
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19aa092e